import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Seo from '../components/Seo';
import { useLang } from '../LangContext';

export default function NotFoundPage() {
  const { lang } = useLang();
  const labels = lang === 'de'
    ? { eyebrow: 'Fehler 404', title: 'Diese Seite existiert nicht.', sub: 'Vielleicht ist sie umgezogen oder du hast den Link falsch getippt. Zurück zur Startseite?', cta: 'Zur Startseite' }
    : { eyebrow: 'Fout 404', title: 'Deze pagina bestaat niet.', sub: 'Misschien is hij verhuisd of typte u de link verkeerd. Terug naar de startpagina?', cta: 'Naar de startpagina' };

  return (
    <article data-testid="not-found" className="relative bg-[#FAF8F2] min-h-[70vh] flex items-center">
      <Seo title={labels.title} description={labels.sub} lang={lang} noindex />
      <div className="max-w-[1440px] mx-auto px-5 lg:px-10 pt-32 pb-24">
        <p className="text-[11.5px] uppercase tracking-[0.22em] text-[#F26B1A] font-medium mb-6">{labels.eyebrow}</p>
        <h1 className="font-display text-[#1F1D1A] text-[44px] sm:text-[64px] lg:text-[96px] leading-[1.02] max-w-3xl">{labels.title}</h1>
        <p className="mt-7 text-[#5C5852] text-[16px] lg:text-[18px] leading-relaxed max-w-xl">{labels.sub}</p>
        <Link to="/" className="pill pill-leaf mt-9 inline-flex">
          {labels.cta} <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </article>
  );
}
